import { render } from "./ElementsNotification.vue?vue&type=template&id=72a939c6"
import script from "./ElementsNotification.vue?vue&type=script&lang=js"
export * from "./ElementsNotification.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__